/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */

const statusMap = {
  0: '未入驻',
  1: '已入驻'
};

export default {
  index: {
    width: '100px',
    label: '序号',
    type: 'index'
  },
  projectName: {
    label: '项目名称',
    prop: 'projectName'
  },
  status: {
    width: '140px',
    label: '入驻状态',
    prop: 'status',
    formatter(v) {
      return statusMap[v.status] || '-';
    }
  },
  taskSum: {
    width: '140px',
    label: '计划任务量',
    prop: 'taskSum'
  },
  finishSum: {
    width: '140px',
    label: '已完成任务量',
    prop: 'finishSum'
  },
  record: {
    width: '140px',
    showToolTip: false,
    label: '任务记录',
    prop: 'record',
    render(h, ctx, row) {
      const vm = ctx.parent;
      const jump = async () => {
        vm.$toRecord({
          ...row,
          ...vm.defaultQuery,
          dateRangeStart: new Date(),
          dateRangeEnd: new Date()
        });
      };
      return (
        <el-button type="text" style="margin: 0 10px" onClick={jump}>
          查看详情
        </el-button>
      );
    }
  }
};
